import { Button, Heading } from "@ariakit/react";
import type { ReactNode } from "react";
import type { RichText } from "../../engine/common.ts";
import { caps } from "../fmt.ts";
import { RichContent } from "./PremiumContent.tsx";
import { loadoutItem } from "./style.css.ts";
import { useGangContext } from "./useGang.ts";

/**
 * A generic item that can be used for both Gits and Vehicles. If a cost is
 * provided it will be shown.
 */
export function LoadoutItem(props: {
  item: { name: string; cost?: number | null; description: RichText };
  premium?: boolean;
  type?: string;
  onRemove: null | (() => void);
  extra?: ReactNode;
}) {
  const { readOnly } = useGangContext();
  const { item, type, extra, onRemove } = props;

  return (
    <div>
      <div className={loadoutItem.header}>
        <Heading className={loadoutItem.heading}>{item.name}</Heading>
        {!!item.cost && (
          <span className={loadoutItem.cost}>{caps(item.cost)}</span>
        )}

        {!readOnly && onRemove && (
          <Button className={loadoutItem.removeButton} onClick={onRemove}>
            x
          </Button>
        )}
      </div>

      <div className={loadoutItem.description}>
        {type && (
          <>
            <em className={loadoutItem.type}>{type}</em>
            {" · "}
          </>
        )}

        {props.premium ? (
          <RichContent>{item.description}</RichContent>
        ) : (
          item.description
        )}
      </div>

      {extra}
    </div>
  );
}
